import type { Recommendation } from '@shared/dream-components/src';

type TargetAction = 'subscribe' | 'view_profile' | 'read_sample_post' | 'click_social_link';
type TriggerSource =
  | 'individual_card_button'
  | 'subscribe_all_button'
  | 'publication_name'
  | 'publication_logo'
  | 'sample_post_link'
  | 'social_icon';

export async function trackRecommendationClicks(
  recommendations: Recommendation[],
  subscriberId: string | undefined,
  subscriptionUuid: string | undefined,
  targetAction: TargetAction,
  triggerSource: TriggerSource,
): Promise<void> {
  if (!recommendations.length) return;
  if (!subscriberId || !subscriptionUuid) return;

  const clicks = recommendations
    .map((r) => ({ id: r.id, impression_token: r.impression_token }))
    .filter((r) => r.id && r.impression_token);

  if (!clicks.length) return;

  await fetch('/recommendations_clicks', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      clicks,
      subscriber_id: subscriberId,
      subscription_uuid: subscriptionUuid,
      target_action: targetAction,
      trigger_source: triggerSource,
    }),
  });
}
